import { render, staticRenderFns } from "./currencySetting.vue?vue&type=template&id=4710e527&scoped=true&"
import script from "./currencySetting.vue?vue&type=script&lang=js&"
export * from "./currencySetting.vue?vue&type=script&lang=js&"
import style0 from "./currencySetting.vue?vue&type=style&index=0&id=4710e527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710e527",
  null
  
)

export default component.exports